import React, { useState, useEffect } from 'react'
import { createStructuredSelector } from 'reselect'
import { connect, Selectors } from '@react-page/core/lib'

import { toast } from 'react-toastify'

import { GET_LIST, useClient } from '@peracto/client'

import ContentBlockEdit from '../ContentBlockEdit'
import ContentBlockAdd from '../ContentBlockAdd'

import * as S from './styled'

const RightPanel = props => {
    const { isEditMode, isPreviewMode } = props

    const [libraryBlocks, setLibraryBlocks] = useState([])
    const [error, setError] = useState(false)

    const { client } = useClient()

    useEffect(() => {
        getLibraryBlocks(true)
    }, [])

    const loadLibraryBlocks = async () => {
        const { data } = await client(GET_LIST, 'contents', {
            id: 'contents',
            filter: { type: 'template' },
            pagination: {
                page: 1,
                perPage: 100,
            },
        })

        return data
    }

    const getLibraryBlocks = async () => {
        try {
            const data = await loadLibraryBlocks()
            props.editor.getLibraryService().setItems(data)
            setLibraryBlocks(data)
        } catch (e) {
            console.error(e)
            toast.error(`There was an issue loading library blocks"`)

            setError(true)
        }
    }

    if (isPreviewMode) {
        return null
    }

    if (isEditMode) {
        return (
            <S.RightPanel>
                <ContentBlockEdit getLibraryBlocks={getLibraryBlocks} {...props} />
            </S.RightPanel>
        )
    }

    return (
        <S.RightPanel>
            <ContentBlockAdd
                getLibraryBlocks={getLibraryBlocks}
                libraryBlocks={libraryBlocks}
                error={error}
                {...props}
            />
        </S.RightPanel>
    )
}

export default connect(
    createStructuredSelector({
        ...Selectors.Display,
    }),
    {}
)(RightPanel)
